// CourseContext.js
import React, { createContext, useState } from 'react';

const CourseContext = createContext();

const CourseProvider = ({ children }) => {
  const [courseId, setCourseId] = useState(null);

  return (
    <CourseContext.Provider value={{ courseId, setCourseId }}>
      {children}
    </CourseContext.Provider>
  );
};

export { CourseContext, CourseProvider };
